import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from "../../shared/shared.module";
import {GroupDashboardScreenComponent} from "./screen/group-dashboard-screen.component";
import {
  ParticipantBehaviorSelectorComponent
} from "./components/participant-behavior-selector/participant-behavior-selector.component";
import {GroupsTableFooterComponent} from "./components/groups-table-footer/groups-table-footer.component";
import {MaterialModule} from "../../shared/material-module";
import {StoreModule} from "@ngrx/store";
import {reducer} from "./core/group-dashboard.reducer";
import {EffectsModule} from "@ngrx/effects";
import {GroupDashboardEffects} from "./core/group-dashboard.effects";
import {ParticipantOrCaregiverInformationFilterComponent} from './components/filters/participant-or-caregiver-information-filter/participant-or-caregiver-information-filter.component';
import {ParticipantOrCaregiverInformationTableComponent} from './components/tables/participant-or-caregiver-information-table/participant-or-caregiver-information-table.component';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import {ParticipantWeightInformationFilterComponent} from './components/filters/participant-weight-information-filter/participant-weight-information-filter.component';
import {ParticipantWeightInformationTableComponent} from './components/tables/participant-weight-information-table/participant-weight-information-table.component';
import { ParticipantBehaviourInformationFilterComponent } from './components/filters/participant-behaviour-information-filter/participant-behaviour-information-filter.component';
import { ParticipantBehaviourInformationTableComponent } from './components/tables/participant-behaviour-information-table/participant-behaviour-information-table.component';


@NgModule({
  declarations: [
    GroupDashboardScreenComponent,
    ParticipantBehaviorSelectorComponent,
    GroupsTableFooterComponent,
    ParticipantOrCaregiverInformationFilterComponent,
    ParticipantOrCaregiverInformationTableComponent,
    ParticipantWeightInformationFilterComponent,
    ParticipantWeightInformationTableComponent,
    ParticipantBehaviourInformationFilterComponent,
    ParticipantBehaviourInformationTableComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    StoreModule.forFeature('ss-cord.group-dashboard', reducer),
    EffectsModule.forFeature(
      [GroupDashboardEffects]
    ),
    InfiniteScrollModule,
  ]
})
export class GroupsDashboardModule {
}
